import * as Sentry from "@sentry/react";

import { isDev, isLocal, isProd, isUat } from "@/common/utilities/env";

const getEnvironment = () => {
  if (isLocal()) return "local";
  if (isDev()) return "dev";
  if (isUat()) return "uat";
  if (isProd()) return "prod";
  return "unknown";
};

// Errors are only reported when a DSN is configured for the build, and never from localhost
export const initSentry = () => {
  const dsn = import.meta.env.REACT_APP_SENTRY_DSN;
  if (!dsn || isLocal() || Sentry.isInitialized()) {
    return;
  }
  Sentry.init({
    dsn,
    environment: getEnvironment(),
    release: import.meta.env.REACT_APP_GIT_SHA,
    initialScope: { tags: { app: "genfive-admin" } },
    ignoreErrors: [/^ResizeObserver loop/],
  });
};

export const setSentryUser = (
  user: { uid: string; email: string | null } | null
) => {
  Sentry.setUser(
    user === null ? null : { id: user.uid, email: user.email ?? undefined }
  );
};
